import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import { FieldPasswordField, Form, Modal, PrimaryButton } from '../../components';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import css from './BookingLoginModal.module.css';

const BookingLoginModal = props => {
  const {
    isOpen,
    email,
    onClose,
    onSubmit,
    onForgotPassword,
    onManageDisableScrolling,
    loginInProgress,
    loginError,
    recoveryInProgress,
    recoveryError,
    recoveryEmailSent,
  } = props;
  const intl = useIntl();
  const passwordRequired = validators.requiredStringNoTrim(
    intl.formatMessage({ id: 'LoginForm.passwordRequired' })
  );

  return (
    <Modal
      id="ReservationContactPage.bookingLogin"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      scrollLayerClassName={css.scrollLayer}
      containerClassName={css.container}
    >
      <div className={css.root}>
        <h2 className={css.title}>
          <FormattedMessage id="ReservationDetailsPage.loginModalTitle" />
        </h2>
        <p className={css.description}>
          <FormattedMessage id="ReservationDetailsPage.loginModalDescription" values={{ email }} />
        </p>

        <div className={css.emailBox}>
          <span className={css.emailLabel}>
            <FormattedMessage id="LoginForm.emailLabel" />
          </span>
          <span className={css.emailValue}>{email}</span>
        </div>

        {recoveryEmailSent ? (
          <div className={css.recoveryConfirmation}>
            <h3 className={css.recoveryTitle}>
              <FormattedMessage id="ReservationDetailsPage.recoveryEmailSentTitle" />
            </h3>
            <p className={css.recoveryText}>
              <FormattedMessage
                id="ReservationDetailsPage.recoveryEmailSentDescription"
                values={{ email }}
              />
            </p>
          </div>
        ) : (
          <FinalForm
            onSubmit={({ password }) => onSubmit(password)}
            render={({ handleSubmit, invalid }) => (
              <Form className={css.form} onSubmit={handleSubmit}>
                <FieldPasswordField
                  id="booking-contact-login-password"
                  name="password"
                  autoComplete="current-password"
                  label={intl.formatMessage({ id: 'LoginForm.passwordLabel' })}
                  placeholder={intl.formatMessage({ id: 'LoginForm.passwordPlaceholder' })}
                  validate={passwordRequired}
                  className={css.passwordField}
                />

                {loginError ? (
                  <p className={css.error}>
                    <FormattedMessage id="AuthenticationPage.loginFailed" />
                  </p>
                ) : null}
                {recoveryError ? (
                  <p className={css.error}>
                    <FormattedMessage id="ReservationDetailsPage.recoveryEmailFailed" />
                  </p>
                ) : null}

                <button
                  type="button"
                  className={css.forgotPassword}
                  onClick={onForgotPassword}
                  disabled={recoveryInProgress || loginInProgress}
                >
                  {recoveryInProgress ? (
                    <FormattedMessage id="ReservationDetailsPage.recoveryEmailSending" />
                  ) : (
                    <FormattedMessage
                      id="LoginForm.forgotPasswordInfo"
                      values={{
                        passwordRecoveryLink: (
                          <span className={css.forgotPasswordLink}>
                            <FormattedMessage id="LoginForm.forgotPassword" />
                          </span>
                        ),
                      }}
                    />
                  )}
                </button>

                <PrimaryButton
                  type="submit"
                  className={css.submitButton}
                  inProgress={loginInProgress}
                  disabled={invalid || loginInProgress || recoveryInProgress}
                >
                  <FormattedMessage id="ReservationDetailsPage.loginAndContinue" />
                  <IconCard brand="rightArrow" />
                </PrimaryButton>
              </Form>
            )}
          />
        )}
      </div>
    </Modal>
  );
};

export default BookingLoginModal;
